import { render, staticRenderFns } from "./ListMenuOption.vue?vue&type=template&id=b1312238"
import script from "./ListMenuOption.vue?vue&type=script&lang=js"
export * from "./ListMenuOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports